const ApiError = require('@/lib/Api/ApiError');

class NotFoundApiError extends ApiError {
    constructor(message = 'Not found', responseData = {}, rawResponse = {}) {
        super(message, 404, responseData, rawResponse);

        this.name = 'NotFoundApiError';
    }
}

module.exports = NotFoundApiError;
